import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'

const itemDefault = () => ({
  id: '',
  hospitalId: null,
  descricao: '',
  codigoHis: '',
  tipo: '',
  classificacao: '',
  tipoCusto: '',
})

const filtrosDefault = () => ({
  descricao: '',
  codigoHis: '',
  hospitalId: null,
  origem: null,
  periodoCriacaoInicio: null,
  periodoCriacaoFim: null,
})

@Module({ namespaced: true, name: 'CentroDeCustoStore' })
export default class CentroDeCustoStore extends VuexModule {
  lista: any[] = []
  total: number = 0
  pagina: number = 1
  qtdPorPagina: number = 20
  filtros: any = filtrosDefault()
  item: any = itemDefault()
  modalCriarEditar: boolean = false
  origemOptions: any[] = []
  hospitais: any[] = []

  @Mutation
  setLista(value: any[]) { this.lista = value }

  @Mutation
  setTotal(value: number) { this.total = value }

  @Mutation
  setPagina(value: number) { this.pagina = value }

  @Mutation
  limparFiltros() {
    this.filtros = filtrosDefault()
    this.pagina = 1
  }

  @Mutation
  setItem(value: any) { this.item = { ...value } }

  @Mutation
  limparItem() { this.item = itemDefault() }

  @Mutation
  setModalCriarEditar(value: boolean) { this.modalCriarEditar = value }

  @Mutation
  setOrigemOptions(value: any[]) { this.origemOptions = value }

  @Mutation
  setHospitais(value: any[]) { this.hospitais = value }

  @Action
  async carregarEnums() {
    const origem = await RemuneracaoMedicaApi.getListagemEnum('OrigemCadastro')
    if (origem.success) this.context.commit('setOrigemOptions', origem.data || [])
  }

  @Action
  async carregarHospitais() {
    const request = await RemuneracaoMedicaApi.getFontePagadoraAll()
    if (request.success) this.context.commit('setHospitais', request.data || [])
  }

  @Action
  async getAll() {
    try {
      const params = { ...this.filtros, pagina: this.pagina, qtdPorPagina: this.qtdPorPagina }
      const request = await RemuneracaoMedicaApi.getCentroDeCustoListagem(params)
      if (request.success) {
        this.context.commit('setLista', request.data.itens || [])
        this.context.commit('setTotal', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar os centros de custo.' }
    }
  }

  @Action
  async salvar() {
    try {
      const params = {
        id: this.item.id || null,
        hospitalId: this.item.hospitalId,
        descricao: this.item.descricao,
        codigoHis: this.item.codigoHis,
        tipo: this.item.tipo,
        classificacao: this.item.classificacao,
        tipoCusto: this.item.tipoCusto,
      }
      return await RemuneracaoMedicaApi.upsertCentroDeCusto(params)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o centro de custo.' }
    }
  }

  @Action
  async remover(id: string) {
    try {
      return await RemuneracaoMedicaApi.removeCentroDeCusto(id)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao excluir o centro de custo.' }
    }
  }
}
